<h2 mat-dialog-title>Closing Alert</h2>
<mat-dialog-content>
    <app-dynamic-form-v2
        [formDefinition]="dialogData.form.formDefinition"
        (form)="form.next($event)"
    />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button (click)="editModel()" CdkFocusInitial>Ok</button>
</mat-dialog-actions>
